module.exports = "<p>\r\n    reload works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/app_element/client-detail/reload/reload.component.html
// module id = ./src/app/app_manager/app_element/client-detail/reload/reload.component.html
// module chunks = main